export default {
  state:{
    message: {
      show: false, 
      title: '',
      text: '',
      btnText: ''
    }
  },
  mutations: {
    showMessage(state, msg) {
      state.message . title = msg.title
      state.message . text = msg.text
      state.message . btnText = msg.btnText
      state.message . show = true
    },
    hideMessage(state) {
      state.message . show = false
    }
  },
}